import { h, Component } from 'preact'
import { connectHierarchicalMenu } from 'react-instantsearch/connectors'
import Icon from '../../assets'
import Count from './ResultsCount'
import Phrase from '../../../libs/translationsUtils/phrase'

type CategoryHit = {
  label: string,
  value: string,
  items: Array<CategoryHit>,
  count:number,
  isRefined: boolean
}

type Props = {
  items: Array<CategoryHit>,
  currentRefinement?: string,
  defaultRefinement?: string,
  refine: Function,
  createURL: Function,
  title?: string,
  isChild?: boolean,
}

type State = {
  isShowMoreBtn: boolean
}

export class HierarchicalMenu extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isShowMoreBtn: true
    }

    this.handleShowMore = this.handleShowMore.bind(this)
  }

  handleShowMore () {
    this.setState({
      isShowMoreBtn: !this.state.isShowMoreBtn
    })
  }

  render ({items, refine, createURL, title, isChild = false}: Props, {isShowMoreBtn}: State) {
    return (
      <div className='instant-search__category-filter'>
        {title &&
          <h4>{title}</h4>
        }

        {!items.length
          ? <div class='instant-search__filter-no-results'><Phrase p='No results' m='Control' /></div>
          : (
            <ul>
              {items.map((item, index) => (
                <li key={index}
                  className={`instant-search__filter-list-item ${!isChild && isShowMoreBtn && index > 4 ? 'instant-search__filter-list-item--hide' : ''}`}>
                  <div className='instant-search-filter__label-wrapper'>
                    <span
                      onClick={event => {
                        event.preventDefault();
                        refine(item.value);
                      }}
                      className={`${item.isRefined ? 'refined' : ''} ${item.isRefined && (isChild || (item.items?.length > 1 && item.items?.filter(item => item.isRefined === true).length === 0)) ? 'bold' : ''}`}
                    >
                      {item.label}
                      <Count count={item.count}/>
                      {
                        ( !isChild && !item.items && <Icon size={20} color='#6B707E' icon='arrowDropdown' customClass='instant-search-filter__closed' />)
                        || (!isChild && item.items && <Icon size={20} color='#6B707E' icon='arrowDropUp' customClass='instant-search-filter__open' />)
                      }
                    </span>
                  </div>

                  {item.items && (
                    <HierarchicalMenu
                      items={item.items}
                      refine={refine}
                      createURL={createURL}
                      isChild
                    />
                  )}
                </li>
              ))}

              {isShowMoreBtn && items.length > 5 && !isChild &&
              <li className='instant-search__filter-list-item instant-search__filter-list-item--showMore'
                onClick={this.handleShowMore}><Phrase m='Common' p='advanced.search.filter.show.more' /></li>
              }
            </ul>
          )
        }
      </div>
    )
  }
}

const CustomHierarchicalMenu = connectHierarchicalMenu(HierarchicalMenu)

export default CustomHierarchicalMenu
